export enum BoardOptionalParams {
  Scope = 'scope',
  Strand = 'strand',
  Topic = 'topic',
  GradeLevel = 'gradeLevel',
  Term = 'term',
  Subterm = 'subterm',
  Year = 'year',
  Class = 'classId',
  School = 'schoolId',
  Region = 'regionId',
  Board = 'boardId',
  Student = 'studentId'
}
